import { render, staticRenderFns } from "./CompanyInvoiceInfo.vue?vue&type=template&id=6c5cf0d0&"
import script from "./CompanyInvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports